import React from 'react';
import type { FC } from 'react';
import { ListLabels } from './listTypes';
import QuestionList from './questionList';

const QuestionUserList: FC = () => <QuestionList listType={ListLabels.user} />;

export default QuestionUserList;
